<template>
  <div>
    <page-header
      icon="mdi-finance"
      :title="$t('finance_page_title')"
      :subtitle="$t('finance_page_subtitle')"
    />

    <v-tabs v-model="tab" show-arrows background-color="primary" dark>
      <v-tab v-for="item in items" :key="item.value" :value="item.value">
        <v-icon style="margin-right: 7px">{{ item.icon }}</v-icon>
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" :touchless="true">
      <v-tab-item v-for="item in items" :key="item.value">
        <div class="px-4 pt-2">
          <component :is="item.component" v-if="tab === item.value" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import PageHeader from "@/components/global/PageHeader.vue";
import {
  FinanceTabOverview,
  FinanceTabTurnover,
  FinanceTabTransactions,
  FinanceTabBalanceLedger,
  FinanceTabCommissions,
  FinanceTabInvoices,
  FinanceTabPayouts,
  FinanceTabPlatformPayments,
  FinanceTabPromotions,
  FinanceTabRefunds,
  FinanceTabExport,
} from "@/components/restaurant/finance";

export default {
  name: "RestaurantFinance",

  components: { PageHeader },

  data: () => ({
    tab: 0,
  }),

  computed: {
    items() {
      return [
        { tab: this.$t("finance_nav_overview"), icon: "mdi-view-dashboard-outline", component: FinanceTabOverview, value: 0 },
        { tab: this.$t("finance_nav_turnover"), icon: "mdi-chart-line", component: FinanceTabTurnover, value: 1 },
        { tab: this.$t("finance_nav_transactions"), icon: "mdi-swap-horizontal", component: FinanceTabTransactions, value: 2 },
        { tab: this.$t("finance_nav_balance_ledger"), icon: "mdi-book-open-variant", component: FinanceTabBalanceLedger, value: 3 },
        { tab: this.$t("finance_nav_commissions"), icon: "mdi-percent-outline", component: FinanceTabCommissions, value: 4 },
        { tab: this.$t("finance_nav_invoices"), icon: "mdi-file-document-outline", component: FinanceTabInvoices, value: 5 },
        { tab: this.$t("finance_nav_payouts"), icon: "mdi-cash-fast", component: FinanceTabPayouts, value: 6 },
        // "Plaćanja platformi" = "Uplate restorana" - potvrđeno isti endpoint
        // (/platform-payments), duplirani tab uklonjen (ticket #223672 v2).
        {
          tab: this.$t("finance_nav_platform_payments"),
          icon: "mdi-bank-transfer",
          component: FinanceTabPlatformPayments,
          value: 7,
        },
        { tab: this.$t("finance_nav_promotions"), icon: "mdi-tag-heart-outline", component: FinanceTabPromotions, value: 8 },
        { tab: this.$t("finance_nav_refunds"), icon: "mdi-cash-refund", component: FinanceTabRefunds, value: 9 },
        { tab: this.$t("finance_nav_export"), icon: "mdi-export", component: FinanceTabExport, value: 10 },
      ];
    },
  },
};
</script>

<style>
.v-slide-group__prev {
  display: none !important;
}
</style>
